import NativeIcon, { type SvgIconProps } from './NativeIcon';

const FWDChartIcon = (props: SvgIconProps) => {
  return (
    <NativeIcon
      {...props}
      fontSize='inherit'
      viewBox='0 0 24 24'
    >
      <path
        d='M20.4139 4.03125L17.7889 7.3125L15.3274 6.0705L14.7424 5.78925L14.3674 6.32775L11.8121 10.1723L9.44513 8.39025L8.99963 8.0625L8.55413 8.391L5.83538 10.4295L3.18713 9.77325L2.81213 11.2268L5.81213 11.9768L6.16388 12.0705L6.44513 11.859L8.99963 9.9375L11.5541 11.8598L12.1871 12.3278L12.6326 11.6715L15.2576 7.734L17.6711 8.9295L18.2111 9.1875L21.5861 4.96875L20.4139 4.03125ZM15.0461 13.7348L14.4139 14.5313L11.8586 17.7188L9.44513 15.8903L8.99963 15.5625L8.55413 15.891L5.92913 17.8598L3.32813 16.5698L2.67188 17.9295L5.67188 19.4295L6.06938 19.617L6.44438 19.3598L8.99963 17.4375L11.5541 19.3598L12.1399 19.7813L12.5854 19.2188L14.9291 16.2893L17.3666 19.9215L17.9531 20.7653L18.5854 19.9688L21.5854 16.2188L20.4139 15.2813L18.0701 18.2108L15.6326 14.5785L15.0461 13.7348Z'
        fill='currentColor'
      />
    </NativeIcon>
  );
};
export default FWDChartIcon;
